module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_2.80530fe4.jpg";